import Avatar from "react-avatar";
import logo from "../../assets/images/sideLogo.png";
import "./personnelCard.css";

export const PersonnelCard = ({ details, user, noMargin, noLogo }) => {
	return (
		<section
			className={`${
				noMargin ?? "personnel-card-margin"
			} personnel_card_align`}
		>
			{!noLogo && (
				<header className="personnel-card-header">
					<img src={logo} alt={"logo"} className="personnel-image" />
				</header>
			)}
			<div className="personnel-card-content">
				<div className="personnel-card-avatar">
					<Avatar
						className="info-avatar"
						name={user?.fullname}
						size="160"
						src={user?.passPort}
						round={false}
						maxInitials={2}
					/>
				</div>

				<div className="personnel-card-spacer" />

				<div className="personnel-card-details">
					<div className="personnel-details-grid">
						{details?.map((detail, index) => (
							<div className="personnel-detail-item" key={index}>
								<div className="info-container">
									<p className="detail-title">
										{`${detail.title}:`}{" "}
									</p>

									<p className="detail-value">
										{detail.value}
									</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};
